import React from "react";
import { Modal } from "react-bootstrap";
import AddPricingRule from "../../../../shared/components/pricingRule/AddPricingRule";

const AddTradeInMargin = ({
  show,
  isEdit,
  columns,
  setColumns,
  productTags,
  customTypes,
  setByFilter,
  selectedTags,
  editCategory,
  itemMarginUnit,
  categoriesColumn,
  searchCategories,
  customCategories,
  handleSetByChange,
  modalHandleSubmit,
  filterProductType,
  setItemMarginUnit,
  selectedCondition,
  handleSwitchChange,
  selectedCategories,
  customSubCategories,
  modalCheckBoxStatus,
  setSearchCategories,
  setFilterProductType,
  handleCategorySelect,
  productConditionList,
  setSelectedCategories,
  productMarginColumns,
  filterProductCategory,
  setSelectedCondition,
  toggleCustomTradeModal,
  handleSelectedTagsChange,
  setFilterProductCategory,
  defaultCategorySortFieldId,
  setDefaultCategorySortFieldId,
}) => {
  return (
    <Modal
      show={show}
      onHide={toggleCustomTradeModal}
      size="md"
      animation={true}
      centered
      backdrop="static"
      className="add-inventory-modal"
    >
      <AddPricingRule
        isEdit={isEdit}
        columns={columns}
        setColumns={setColumns}
        productTags={productTags}
        customTypes={customTypes}
        setByFilter={setByFilter}
        selectedTags={selectedTags}
        editCategory={editCategory}
        itemMarginUnit={itemMarginUnit}
        categoriesColumn={categoriesColumn}
        searchCategories={searchCategories}
        customCategories={customCategories}
        handleSetByChange={handleSetByChange}
        modalHandleSubmit={modalHandleSubmit}
        filterProductType={filterProductType}
        setItemMarginUnit={setItemMarginUnit}
        selectedCondition={selectedCondition}
        handleSwitchChange={handleSwitchChange}
        selectedCategories={selectedCategories}
        customSubCategories={customSubCategories}
        modalCheckBoxStatus={modalCheckBoxStatus}
        setSearchCategories={setSearchCategories}
        setFilterProductType={setFilterProductType}
        handleCategorySelect={handleCategorySelect}
        productConditionList={productConditionList}
        setSelectedCategories={setSelectedCategories}
        productMarginColumns={productMarginColumns}
        filterProductCategory={filterProductCategory}
        setSelectedCondition={setSelectedCondition}
        toggleCustomTradeModal={toggleCustomTradeModal}
        handleSelectedTagsChange={handleSelectedTagsChange}
        setFilterProductCategory={setFilterProductCategory}
        defaultCategorySortFieldId={defaultCategorySortFieldId}
        setDefaultCategorySortFieldId={setDefaultCategorySortFieldId}
        title={
          !isEdit ? "Add Custom Trade-in Margin" : "Edit Custom Trade-in Margin"
        }
      />
    </Modal>
  );
};

export default AddTradeInMargin;
